export default {
// 模块名称
  personAccess: {
    // 按钮类
    button: {          
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      confirm: '确定',
      close: '关闭',
      view: '详情',
      add: '新增',
      edit: '编辑',
      uninstall: '卸载',
      back: '返回',
      sync: '同步',
      delete: '删除',
      modify: '修改',
      batchDeletion: '批量删除',
      authorization: '授权',
      remove: '移除授权'
    },
    // 文字标签类
    label: {
      staffAccess: '员工通行授权',
      visitorAccess: '外来人员通行授权',
      organizationId: '组织ID',
      organizationName: '组织名称',
      takeEffectTime: '通行生效时间',
      finishTime: '通行失效时间',
      operate: '操作',
      visitorName: '人员姓名',
      visitorType: '人员类型',
      visitorPhone: '人员电话',
      idCard: '身份证号',
      visitorSex: '性别',
      visitorImage: '人员图像',
      passageTime: '通行时间'
    },
    // 提示类
    placeholder: {
      select: '请选择',
      enter: '请输入',
    },
    // 消息类
    message: {
      editSuccess: '修改成功',
      editFailed: '修改失败',
      nospace: '系统名称不能包含空格',
      ipformat: 'IP格式不正确',
      systemname: '请输入系统名称',
      less50: '长度在 1 到 50 个字符',
      less200: '长度在 1 到 200 个字符',
      ip: '请输入IP',
      port: '请输入端口号',
      port2: '请输入正确的端口号',
      account: '请输入登录账号',
      password: '请输入登录密码',
      vcn: '请选择VCN',
      uninstall: '您确定删除该设备吗？',
      numberchar: '只能输入数字和字母',
      onlynumber: '只能输入数字',
      plugins: '请选择插件',
      domain: '请输入域编码',
      deltips: '请选择要删除的设备',
      deltips2: '是否确认删除设备',
      delsuccess: '删除成功',
      delfail: '删除失败',
      secretkey: '请输入密钥',
      nodata: '暂无数据',
      type: '告警类型不能为空',
    },
    // 标题类
    title: {            
      warn: '提示',
      uninstall: '确认',
      noData: '暂无数据',
    }
  }
}
